var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-list-item',{staticStyle:{"padding-left":"30px","flex":"1","margin-right":"-16px"}},[_c('f7-label',[_vm._v("優惠折扣(%)")]),_c('f7-input',{attrs:{"type":"text","placeholder":"請輸入折扣","value":_vm.newDiscount,"clear-button":""},on:{"input":function($event){return _vm.updateDiscount($event.target.value)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }